module.exports = __webpack_public_path__ + "static/media/honda-no-option-selected.60784bf8.svg";